import { computed, unref, type MaybeRef } from 'vue';
import { useHead } from '@unhead/vue';
import { useTenantStore } from '@features/tenant/store/tenant';
import { tenantHead } from '@features/tenant/documentHead';

export const useTenantHead = (viewTitle: MaybeRef<string> = '') => {
  const tenantStore = useTenantStore();

  const head = computed(() =>
    tenantHead(
      {
        brandName: tenantStore.brandName,
        logoUrl: tenantStore.logoUrl,
        socialImageUrl: tenantStore.socialImageUrl,
        origin: window.location.origin,
      },
      unref(viewTitle),
    ),
  );

  useHead({
    title: computed(() => head.value.title),
    meta: computed(() =>
      head.value.meta.map((entry) => ({
        ...(entry.name ? { name: entry.name } : {}),
        ...(entry.property ? { property: entry.property } : {}),
        content: entry.content,
      })),
    ),
    link: computed(() =>
      head.value.link.map((entry) => ({ rel: entry.rel, href: entry.href })),
    ),
  });

  return head;
};
